import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { useCreatePermisoAppMutation } from '../../../store/api/endpoints/permisosAppApiSlice'

import { getUsuarioPermisos } from '../../../store/slices/auth'
import { openFeedback } from '../../../store/slices/feedback'

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { Container, Divider, Grid, Button } from '@mui/material'

import HeaderVista from '../../elementos/HeaderVista'
import Loading from '../../elementos/Loading'
import Input from '../../elementos/Input'
import BotonDesplegable from '../../elementos/BotonDesplegable'

import CheckIcon from '@mui/icons-material/Check'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import NumbersIcon from '@mui/icons-material/Numbers'
import NotesIcon from '@mui/icons-material/Notes'

export default function PermisosAppCrear() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const urlParams = useParams()
    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    const [
        createRegistro,
        {
            data: responseCreateRegistro,
            isUninitialized: isUninitializedCreateRegistro,
            isLoading: isLoadingCreateRegistro,
            isSuccess: isSuccessCreateRegistro,
            isError: isErrorCreateRegistro,
            error: errorDataCreateRegistro,
        }
    ] = useCreatePermisoAppMutation()

    const handleSubmit = (e) => {

        e.preventDefault()
        
        let body = {
            codigo,
            nombre,
            descripcion,
        }
        createRegistro({app: urlParams.app, body: body})
    }

    useEffect(() => {
        if (isSuccessCreateRegistro) {

            dispatch(openFeedback({
                severity: 'success',
                message: "¡Se ha creado el registro!"
            }))

            navigate("/permisos/app/" + urlParams.app)

        }
    }, [isSuccessCreateRegistro])

    useEffect(() => {
        if (isErrorCreateRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataCreateRegistro.data.message
            }))
        }
    }, [isErrorCreateRegistro])

    const [codigo, setCodigo] = useState('')
    const [nombre, setNombre] = useState('')
    const [descripcion, setDescripcion] = useState('')

    if (permisosDelUsuario.indexOf(14) == -1) return (<p>No tienes acceso a crear los permisos.</p>)

    if (isLoadingCreateRegistro) return (<Loading />)

    return (<>
        <HeaderVista
            titulo={
                <Breadcrumbs aria-label="breadcrumb">
                    <Typography color="text.primary">Permisos App</Typography>
                    <Link underline="hover" color="inherit" to={"/permisos/app/" + urlParams.app} style={{ textTransform: 'uppercase' }}>
                        {urlParams.app}
                    </Link>
                    <Typography color="text.primary">Crear</Typography>
                </Breadcrumbs>
            }
            icon={<LockOpenIcon />}
        />
        <form onSubmit={handleSubmit}>
            <Container className="vistaFormulario formulario" component="main" maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Input
                            label="Codigo"
                            icon={<NumbersIcon />}
                            value={codigo}
                            onChange={setCodigo}
                            type="tel"
                            restricciones={['soloNumeros']}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Input
                            label="Nombre"
                            icon={<LockOpenIcon />}
                            value={nombre}
                            onChange={setNombre}
                            type="text"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Input
                            label="Descripcion"
                            icon={<NotesIcon />}
                            value={descripcion}
                            onChange={setDescripcion}
                            type="text"
                            multiline
                            required
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='footerFormulario'>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="success" startIcon={<CheckIcon />} >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </form>

    </>)

}

